"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toByteArray = function (base64) {
    var bytes = window.atob(base64);
    var byteArrays = [];
    for (var offset = 0; offset < bytes.length; offset += 1024) {
        var sliceOf1024Bytes = bytes.slice(offset, offset + 1024);
        var bytesAsCharCodes = new Array(sliceOf1024Bytes.length);
        for (var i = 0; i < sliceOf1024Bytes.length; i++) {
            bytesAsCharCodes[i] = sliceOf1024Bytes.charCodeAt(i);
        }
        var byteArray = new Uint8Array(bytesAsCharCodes);
        byteArrays.push(byteArray);
    }
    return byteArrays;
};
exports.default = {
    toByteArray: toByteArray,
};
